import { createContext } from "react";

const ClassSchedulerContext = createContext();

export default ClassSchedulerContext;
